"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Drawer = void 0;
var logger_1 = require("../utils/logger");
var waitUtil_1 = require("../utils/waitUtil");
/*
 drawerの目的
  UIのHTMLとcanvasを描画する。
*/
var Drawer = /** @class */ (function () {
    function Drawer(gameContainer) {
        var _this = this;
        this.isSkip = false;
        this.readySkip = false;
        this.gameScreen = gameContainer;
        // ウィンドウのリサイズ時にスケールを調整
        window.addEventListener('resize', function () { return _this.adjustScale(_this.gameScreen); });
        // 初期ロード時にもスケールを調整
        this.adjustScale(this.gameScreen);
    }
    Drawer.prototype.setScreen = function (screenHtml, resolution) {
        this.screenHtml = screenHtml;
        this.nameView = screenHtml.querySelector('#nameView');
        this.messageText = screenHtml.querySelector('#messageView');
        this.interactiveView = screenHtml.querySelector('#interactiveView');
        // canvasをDOMに追加する
        var canvas = document.createElement('canvas');
        canvas.width = resolution.width || 1280;
        canvas.height = resolution.height || 720;
        // canvasのコンテキストを取得する
        this.gameScreen.appendChild(canvas);
        this.ctx = canvas.getContext('2d');
        // 黒で塗りつぶす
        this.ctx.fillStyle = 'black';
        this.ctx.fillRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height);
        // 初期ロード時にもスケールを調整
        this.adjustScale(this.gameScreen);
        // フェード用キャンバスをDOMに追加する
        this.fadeCanvas = document.createElement('canvas');
        this.fadeCanvas.className = 'fadeCanvas';
        this.fadeCanvas.style.position = 'absolute';
        this.fadeCanvas.style.top = '0';
        this.fadeCanvas.style.left = '0';
        this.fadeCanvas.style.pointerEvents = 'none'; // クリックイベントを通過させる
        this.gameScreen.insertBefore(this.fadeCanvas, document.getElementById('messageWindow'));
        this.fadeCtx = this.fadeCanvas.getContext('2d');
        // フェード用キャンバスのサイズを設定
        this.fadeCanvas.width = resolution.width;
        this.fadeCanvas.height = resolution.height;
    };
    Drawer.prototype.drawName = function (name) {
        this.nameView.innerHTML = name;
    };
    Drawer.prototype.drawText = function (text, wait, containerElement) {
        return __awaiter(this, void 0, void 0, function () {
            var element, _i, text_1, char;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        (0, logger_1.outputLog)('drawText', 'debug', { text: text, wait: wait, containerElement: containerElement });
                        element = this.messageText;
                        // テキストを表示するコンテナ要素を指定した場合は、その要素に追加する
                        if (containerElement) {
                            this.messageText.appendChild(containerElement);
                            element = containerElement;
                        }
                        _i = 0, text_1 = text;
                        _a.label = 1;
                    case 1:
                        if (!(_i < text_1.length)) return [3 /*break*/, 7];
                        char = text_1[_i];
                        //prettier-ignore
                        setTimeout(function () { _this.readySkip = true, wait; });
                        if (!!this.isSkip) return [3 /*break*/, 3];
                        element.innerHTML += char;
                        return [4 /*yield*/, (0, waitUtil_1.sleep)(wait)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        if (this.readySkip) {
                            element.innerHTML += text.slice(element.textContent.length);
                            this.readySkip = false;
                            this.isSkip = false;
                            return [3 /*break*/, 7];
                        }
                        _a.label = 4;
                    case 4: return [4 /*yield*/, (0, waitUtil_1.sleep)(wait)];
                    case 5:
                        _a.sent();
                        _a.label = 6;
                    case 6:
                        _i++;
                        return [3 /*break*/, 1];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    Drawer.prototype.drawLineBreak = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                // メッセージテキストに改行を追加する
                this.messageText.innerHTML += '<br>';
                return [2 /*return*/];
            });
        });
    };
    Drawer.prototype.clearText = function () {
        if (this.messageText) {
            this.messageText.innerHTML = '';
        }
    };
    Drawer.prototype.createDecoratedElement = function (element) {
        switch (element.type) {
            case 'color':
                var span = document.createElement('span');
                span.style.color = element.value;
                return span;
            case 'ruby':
                var ruby = document.createElement('ruby');
                var rt = document.createElement('rt');
                rt.textContent = element.text;
                ruby.appendChild(rt);
                return ruby;
            case 'b':
                return document.createElement('strong');
            case 'i':
                return document.createElement('i');
            default:
                (0, logger_1.outputLog)("Unknown decoration type: ".concat(element.type), 'warn');
                return document.createElement('span');
        }
    };
    Drawer.prototype.drawChoices = function (choices) {
        return __awaiter(this, void 0, void 0, function () {
            var isSelect, selectId, onSelect, interactiveView, _loop_1, this_1, _i, _a, choice;
            var _this = this;
            var _b, _c;
            return __generator(this, function (_d) {
                isSelect = false;
                selectId = 0;
                onSelect = 0;
                interactiveView = document.querySelector('#interactiveView');
                if (choices.position == 'auto' || choices.position === undefined) {
                    interactiveView.className = 'auto';
                }
                else {
                    interactiveView.className = 'manual';
                }
                _loop_1 = function (choice) {
                    var defaultImage = choice.default !== undefined ? choice.default : './src/resource/system/systemPicture/02_button/button.png';
                    var hoverImage = choice.hover !== undefined ? choice.hover : './src/resource/system/systemPicture/02_button/button2.png';
                    var selectImage = choice.select !== undefined ? choice.select : './src/resource/system/systemPicture/02_button/button3.png';
                    var button = document.createElement('div');
                    button.className = 'choice';
                    if (interactiveView.className == 'manual') {
                        button.style.position = 'absolute';
                        button.style.top = ((_b = choice.position) === null || _b === void 0 ? void 0 : _b.y) || 0;
                        button.style.left = ((_c = choice.position) === null || _c === void 0 ? void 0 : _c.x) || 0;
                    }
                    button.style.color = choice.color !== undefined ? choice.color.default : 'black';
                    button.style.width = '100%';
                    button.style.height = '50px';
                    button.style.backgroundImage = "url(".concat(defaultImage, ")");
                    button.style.textAlign = 'center';
                    button.style.backgroundRepeat = 'no-repeat';
                    button.style.backgroundPosition = 'center';
                    button.style.paddingTop = '20px';
                    button.addEventListener('mouseenter', function () {
                        // マウスが要素の上にあるときの背景色
                        this.style.backgroundImage = "url(".concat(hoverImage, ")");
                        this.style.color = choice.color !== undefined ? choice.color.hover : 'black';
                    });
                    button.addEventListener('mouseleave', function () {
                        // マウスが要素から離れたときの背景色
                        this.style.backgroundImage = "url(".concat(defaultImage, ")");
                        this.style.color = choice.color !== undefined ? choice.color.default : 'black';
                    });
                    button.addEventListener('mousedown', function () {
                        // マウスが要素を選択したときの背景色
                        this.style.backgroundImage = "url(".concat(selectImage, ")");
                        this.style.color = choice.color !== undefined ? choice.color.select : 'black';
                    });
                    button.innerHTML = choice.label;
                    button.onclick = function () {
                        (0, logger_1.outputLog)('click', 'debug', choice);
                        _this.interactiveView.querySelectorAll('.choice').forEach(function (element) {
                            var _a;
                            (_a = element.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(element);
                        });
                        selectId = choice.id;
                        onSelect = choice.content;
                        isSelect = true;
                    };
                    this_1.interactiveView.appendChild(button);
                };
                this_1 = this;
                // 選択肢を表示
                for (_i = 0, _a = choices.content; _i < _a.length; _i++) {
                    choice = _a[_i];
                    _loop_1(choice);
                }
                // 選択待ち
                return [2 /*return*/, new Promise(function (resolve) {
                        var intervalId = setInterval(function () {
                            if (isSelect) {
                                clearInterval(intervalId);
                                resolve({ selectId: selectId, onSelect: onSelect });
                            }
                        }, 100);
                    })];
            });
        });
    };
    Drawer.prototype.fadeIn = function () {
        return __awaiter(this, arguments, void 0, function (duration, img, option) {
            if (duration === void 0) { duration = 1000; }
            return __generator(this, function (_a) {
                (0, logger_1.outputLog)('Fade in', 'debug', duration);
                return [2 /*return*/, this.fade(0, 1, duration, img, option)];
            });
        });
    };
    Drawer.prototype.fadeOut = function () {
        return __awaiter(this, arguments, void 0, function (duration, img, option) {
            if (duration === void 0) { duration = 1000; }
            return __generator(this, function (_a) {
                (0, logger_1.outputLog)('Fade out', 'debug', duration);
                return [2 /*return*/, this.fade(1, 0, duration, img, option)];
            });
        });
    };
    Drawer.prototype.fade = function (start, end, duration, img, option) {
        var _this = this;
        return new Promise(function (resolve) {
            var startTime = performance.now();
            var pos = (option === null || option === void 0 ? void 0 : option.pos) || {
                x: 0,
                y: 0,
            };
            var size = (option === null || option === void 0 ? void 0 : option.size) || { width: _this.fadeCanvas.width, height: _this.fadeCanvas.height };
            var reverse = (option === null || option === void 0 ? void 0 : option.look) || false;
            var animate = function (currentTime) {
                var elapsedTime = currentTime - startTime;
                var progress = Math.abs(Math.min(elapsedTime / duration, 1));
                var currentAlpha = start + (end - start) * progress;
                _this.fadeCtx.clearRect(0, 0, _this.fadeCanvas.width, _this.fadeCanvas.height);
                _this.fadeCtx.globalAlpha = currentAlpha;
                if (img) {
                    _this.drawCanvas(img, pos, size, reverse, _this.fadeCtx);
                }
                else {
                    _this.fadeCtx.fillRect(0, 0, _this.fadeCanvas.width, _this.fadeCanvas.height);
                }
                (0, logger_1.outputLog)('Fade animation', 'debug', { progress: progress, alpha: currentAlpha });
                if (progress < 1) {
                    requestAnimationFrame(animate);
                }
                else {
                    (0, logger_1.outputLog)('Fade animation complete', 'debug');
                    _this.clear(_this.fadeCtx);
                    resolve();
                }
            };
            requestAnimationFrame(animate);
        });
    };
    Drawer.prototype.show = function (displayedImages) {
        var _this = this;
        this.ctx.clearRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height);
        var _loop_2 = function (key) {
            var img = displayedImages[key].image;
            var pos = displayedImages[key].pos || {
                x: 0,
                y: 0,
            };
            var size = displayedImages[key].size;
            var reverse = displayedImages[key].look || false;
            var entry = displayedImages[key].entry || { time: 1, wait: false };
            if (entry.wait) {
                // 表示開始までの遅延処理
                setTimeout(function () {
                    _this.drawCanvas(img, pos, size, reverse);
                }, entry.time * 1000);
            }
            else {
                this_2.drawCanvas(img, pos, size, reverse);
            }
        };
        var this_2 = this;
        for (var key in displayedImages) {
            _loop_2(key);
        }
    };
    Drawer.prototype.moveTo = function (name, displayedImages, pos, durning) {
        var _this = this;
        return new Promise(function (resolve) {
            var target = displayedImages[name];
            var startPos = { x: target.pos.x, y: target.pos.y };
            var dest = { x: startPos.x + Number(pos.x), y: startPos.y + Number(pos.y) };
            var startTime = performance.now();
            var move = function (currentTime) {
                var elapsedTime = (currentTime - startTime) / 1000; // 秒単位の経過時間
                var progress = Math.min(elapsedTime / durning, 1); // 0から1の進捗
                target.pos.x = startPos.x + (dest.x - startPos.x) * progress;
                target.pos.y = startPos.y + (dest.y - startPos.y) * progress;
                _this.show(displayedImages);
                if (progress < 1) {
                    window.requestAnimationFrame(move);
                }
                else {
                    // 最終位置を正確に設定
                    target.pos.x = dest.x;
                    target.pos.y = dest.y;
                    _this.show(displayedImages);
                    resolve(null);
                }
            };
            window.requestAnimationFrame(move);
        });
    };
    Drawer.prototype.clear = function (ctx) {
        if (ctx === undefined) {
            ctx = this.ctx;
        }
        ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
    };
    Drawer.prototype.drawCanvas = function (img, pos, size, reverse, ctx) {
        (0, logger_1.outputLog)('drawCanvas', 'debug', { img: img, pos: pos, size: size, reverse: reverse });
        if (ctx === undefined) {
            ctx = this.ctx;
        }
        var canvas = img.draw(reverse).getCanvas();
        // canvasから画像を取得して、this.ctxに描画
        ctx.drawImage(canvas, 0, 0, canvas.width, canvas.height, pos.x, pos.y, canvas.width, canvas.height); //CanvasRenderingContext2D.drawImage: Passed-in canvas is empty
    };
    Drawer.prototype.adjustScale = function (targetElement) {
        // ターゲット要素の元の幅と高さ
        var originalWidth = targetElement.scrollWidth; // 例: 1280px
        var originalHeight = targetElement.scrollHeight; // 例: 720px
        // ビューポートの幅と高さを取得
        var viewportWidth = window.innerWidth;
        var viewportHeight = window.innerHeight;
        // 幅と高さのスケールを計算
        var scaleX = viewportWidth / originalWidth;
        var scaleY = viewportHeight / originalHeight;
        // 幅と高さのうち、小さい方のスケールを選択（アスペクト比を維持）
        var scale = Math.min(scaleX, scaleY);
        // ターゲット要素にスケールを適用
        targetElement.style.transform = "scale(".concat(scale, ")");
    };
    Drawer.prototype.setVisibility = function (name, isVisible) {
        var target = this.screenHtml.querySelector(name);
        if (target) {
            target.style.visibility = isVisible ? 'visible' : 'hidden';
        }
    };
    return Drawer;
}());
exports.Drawer = Drawer;
//# sourceMappingURL=drawer.js.map